import QualifyingQuestionTemplatesPage from './qualifyingQuestionTemplatesPage.view';

export default QualifyingQuestionTemplatesPage;
